import i18next from 'i18next';

export default i18next;

export const exists = i18next.exists.bind(i18next);
export const init = i18next.init.bind(i18next);
export const t = i18next.t.bind(i18next);
